import LoggingService from 'client/util/LoggingService';
import Vue from 'vue';

export const ModalEvents = {
  close: 'close',
  open: 'open',

  /**
   * Triggered in TheModal when the semi-transparent overlay is transitioned
   * out. Clients can listen for this event to wait until TheModal animation is
   * done.
   */
  transitionEnd: 'transitionEnd',
};

const { close, open } = ModalEvents;

/**
 * Use this event bus as an api to communicate with TheModal component.
 */
export default new Vue({
  name: 'ModalEventBus',

  methods: {
    close() {
      LoggingService.debug('ModalEventBus.close');
      this.isOpen = false;
      this.$emit(close);
    },

    /**
     * https://jumpcloud.atlassian.net/browse/CO-94
     *
     * Do not use this method going forward. We are planning on
     * retiring ModalEventBus in favor of the ui-components modal flow,
     * which is placing it in the parent component and triggering it via
     * v-if.
     *
     * This was needed to solve a race condition between two modals both
     * trying to pop on pageload. The second modal was overwriting the first
     * one, so we needed a way to see if there's a modal already open.
     *
     * More information in the "DEV NOTES" section in the ticket above.
     *
     * Once again - do not use unless absolutely necessary.
     */
    isModalOpen() {
      return this.isOpen;
    },

    open(payload) {
      LoggingService.debug('ModalEventBus.open');
      this.isOpen = true;
      this.$emit(open, payload);
    },
  },
});
